import { useContext, useMemo } from 'react'
import { zoomPower } from '../functions/zoomPower'
import { CutterContext } from '../../contexts/CutterContext'

const maxReducedSourceLimit = 1_000_000

export function useMaxCachedReducedDataLength(zoomStep: number) {
  const { audioBuffer } = useContext(CutterContext)

  return useMemo(
    () =>
      audioBuffer.length < maxReducedSourceLimit ? zoomPower(audioBuffer.length, zoomStep) : maxReducedSourceLimit,
    [audioBuffer, zoomStep],
  )
}
